import React, { useState, useEffect, useRef } from '../node_modules/react';

function App() {
    const node = useRef();
    const [getValue, setValue] = useState("");
    const [getSuggestions, setSuggestions] = useState([]);
    const [getData, setData] = useState({'input':{'label':'', 'placeholder':''}});

    useEffect(() => {
        const getLocationId = () => {
            const el = document.getElementById('stationRoot');
            return el ? el.dataset.locationId : '117';
        }
        fetch(`/api/search/stations/${getLocationId()}`)
            .then(response => response.json())
            .then(data => [setData(data)]);

        document.addEventListener("mousedown", handleClick);
        return () => {
            document.removeEventListener("mousedown", handleClick);
        };
    }, []);

    useEffect(() => {
        if (getValue !== "") {
            let searchVal = getValue.toLowerCase();
            let matches = getData['stations'].filter(item => item.name.toLowerCase().includes(searchVal) || item.address.toLowerCase().includes(searchVal));

            setSuggestions(matches);
        } else {
            setSuggestions([]);

        }
    }, [getValue]);

    const handleClick = (e) => {
        if (node.current.contains(e.target)) {
            return;
        }
        handleClickOutside();
    };

    const handleClickOutside = () => {
        setSuggestions([]);
        setValue("");
    };

    return (
        <div ref={node}>

        </div>
    );
}

export default App;



// WEBPACK FOOTER //
// ./search/app.js